import { SearchField } from '@frontend/design-system';
import { useCompactTableContext } from '../../../context/compact-table-context';

export const CompactTableSearch = () => {
  const { searchFieldProps, tableId } = useCompactTableContext();

  if (!searchFieldProps) return null;
  return <SearchField name={`${tableId}-search-field`} {...searchFieldProps} />;
};
